import * as React from 'react';

import './modal.css';

import { ModalProps } from '../../types';

class Modal extends React.Component<ModalProps> {
  constructor(props: ModalProps) {
    super(props);
  }

  public render() {
    let modalClasses = 'modal generic-modal';
    if (this.props.isActive) {
      modalClasses += ' is-active';
    }

    return (
      <div
          className={modalClasses}
          id={this.props.id}
      >
        <div className="modal-background" />
        <div className="modal-content">
          <div className="box">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }

}

export default Modal;



// WEBPACK FOOTER //
// ./src/common/modal/Modal.tsx